import type { UseMutationProps } from '@ztechapps/common.hook'
import { useMutation } from '@ztechapps/common.hook'
import type { GenerateBlogTagsArgs } from '@ztechapps/common.contract'
import { generateBlogTagsMutation } from '../graphql/generateBlogTags'

const defaultQuery = generateBlogTagsMutation

/**
 * Hook to generate blog tags using AI
 *
 * @example
 * ```tsx
 * const [generateTags, , { loading, error }] = useGenerateBlogTags()
 *
 * const handleGenerate = async () => {
 *   const result = await generateTags({ input: { blogId: 'blog-123' } })
 *   const tags = result?.data?.generateBlogTags ?? []
 * }
 * ```
 */
export type UseGenerateBlogTagsResult = ReturnType<
  typeof useMutation<{ generateBlogTags: string[] }, GenerateBlogTagsArgs>
>

export const useGenerateBlogTags = (
  { query: queryProp, ...props } = {} as UseMutationProps
): UseGenerateBlogTagsResult => {
  const query = queryProp ?? defaultQuery
  return useMutation<{ generateBlogTags: string[] }, GenerateBlogTagsArgs>({ query, ...props })
}
